/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * Mapping utility for wizard step illustration icons.
 * Each key corresponds to a specific wizard step option.
 * SVGs are the color (active) variants — grayscale is handled via CSS filter.
 */

import citizenSvg from './citizen.svg';
import nonCitizenSvg from './non-citizen.svg';
import seniorSvg from './senior.svg';
import accessibleSvg from './accessible.svg';
import goldStarSvg from './gold-star.svg';
import fourthGraderSvg from './fourth-grader.svg';
import militarySvg from './military.svg';
import singleLocationSvg from './single-location.svg';
import multipleLocationsSvg from './multiple-locations.svg';
import carSvg from './car.svg';
import motorcycleSvg from './motorcycle.svg';
import bicycleSvg from './bicycle.svg';

export type WizardIconName =
    | 'citizen'
    | 'non-citizen'
    | 'senior'
    | 'accessible'
    | 'gold-star'
    | 'fourth-grader'
    | 'military'
    | 'single-location'
    | 'multiple-locations'
    | 'car'
    | 'motorcycle'
    | 'bicycle';

const WIZARD_ICONS: Record<WizardIconName, string> = {
    citizen: citizenSvg,
    'non-citizen': nonCitizenSvg,
    senior: seniorSvg,
    accessible: accessibleSvg,
    'gold-star': goldStarSvg,
    'fourth-grader': fourthGraderSvg,
    military: militarySvg,
    'single-location': singleLocationSvg,
    'multiple-locations': multipleLocationsSvg,
    car: carSvg,
    motorcycle: motorcycleSvg,
    bicycle: bicycleSvg,
};

/** Resolves a wizard icon name to its SVG asset path. */
export function getWizardIcon(name: WizardIconName): string {
    return WIZARD_ICONS[name];
}

/** Preloads all wizard SVG illustrations into the browser cache. */
export function preloadWizardIcons(): void {
    Object.values(WIZARD_ICONS).forEach((src) => {
        const img = new Image();
        img.src = src;
    });
}
